import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import SharedProviders_0_0 from './extensions/d8faacafefa58af53b440d060d61a7eb1b1051554a461e8519f357d3a180e7da/navBarModifier';
import SharedProviders_1_0 from './extensions/multivendor-ui-extensions/providers';
import SharedProviders_2_0 from './extensions/software-houses/providers';
import SharedProviders_3_0 from './extensions/statistics/providers';
import SharedProviders_4_0 from './extensions/credits-and-highlights/providers';
import SharedProviders_5_0 from './extensions/customers/providers';


@NgModule({
    imports: [CommonModule, ],
    providers: [...SharedProviders_0_0, ...SharedProviders_1_0, ...SharedProviders_2_0, ...SharedProviders_3_0, ...SharedProviders_4_0, ...SharedProviders_5_0],
})
export class SharedExtensionsModule {}
